import { useRouter } from "@tanstack/react-router";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Trans } from "@lingui/react/macro";
import { LogOutIcon, MoreVerticalIcon, UserCircleIcon } from "lucide-react";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { useAuth } from "@/auth/useAuth.ts";
import { useUserQuery } from "@/modules/user/api/useUser.ts";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar.tsx";

export function NavUserMenu() {
  const { isMobile } = useSidebar();
  const { logout } = useAuth();
  const { data } = useUserQuery();
  const router = useRouter();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="h-8 w-8 rounded-lg">
                <AvatarImage src={data?.avatarUrl} alt={data?.lastName} />
                <AvatarFallback className="rounded-lg">FN</AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{`${data?.firstName} ${data?.lastName}`}</span>
                <span className="truncate text-xs text-muted-foreground">{data?.email}</span>
              </div>
              <MoreVerticalIcon className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage src={data?.avatarUrl} alt={data?.lastName} />
                  <AvatarFallback className="rounded-lg">FN</AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">{`${data?.firstName} ${data?.lastName}`}</span>
                  <span className="truncate text-xs text-muted-foreground">{data?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={() => router.navigate({ to: "/user/user-profile" })}>
                <UserCircleIcon />
                <Trans>User profile</Trans>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuItem onClick={logout}>
              <LogOutIcon />
              <Trans>Log out</Trans>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
